module.exports = __webpack_public_path__ + "static/media/learning11Step.cfa76523.png";